module.exports = __webpack_public_path__ + "static/media/bylaws-green.fa28ec77.svg";